import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CompanyLogo } from "../../../components/CompanyLogo";
import { Settings } from "@mui/icons-material";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { Skeleton } from "../../../components/loading";

export function VendorSummary(props: {
  vendorId: number;
  vendorUrl: string;
  isLoading: boolean;
  vendorName: string;
  vendorDescription?: string;
}) {
  return (
    <OutlinedPaper
      id="vendor-summary-card"
      data-testid="catalog-vendor-summary-card"
      sx={{ p: 2 }}
    >
      <Stack gap={1}>
        <Box display="flex" gap={1}>
          <Box sx={{ width: "64px" }}>
            <Skeleton
              isLoading={props.isLoading}
              width={64}
              height={64}
              variant="circular"
            >
              <CompanyLogo
                size={64}
                fallback={<Settings />}
                domain={props.vendorUrl}
                variant="circular"
              />
            </Skeleton>
          </Box>
          <Stack gap={1}>
            <Skeleton isLoading={props.isLoading} width={140} height={25}>
              <Typography variant="h3">{props.vendorName}</Typography>
            </Skeleton>
            <Box mt="4px" display="flex" gap="4px">
              <Typography variant="body2">URL:</Typography>
              <Skeleton isLoading={props.isLoading} width={100} variant="text">
                <Typography variant="body2">
                  <Link
                    id="vendor-link"
                    data-testid="catalog-vendor-url-link"
                    underline="none"
                    href={`https://${props.vendorUrl}`}
                    target="_blank"
                  >
                    {props.vendorUrl}
                  </Link>
                </Typography>
              </Skeleton>
            </Box>
          </Stack>
        </Box>
        <Box mt="8px">
          <Skeleton isLoading={props.isLoading} height={100}>
            <Typography variant="body1">{props.vendorDescription}</Typography>
          </Skeleton>
        </Box>
      </Stack>
    </OutlinedPaper>
  );
}
